<div class="logout-button" (click)="logout()">
  <ion-icon class="item-red" name="log-out-outline" slot="start" size="large"></ion-icon>
</div>
